import {ERROR_CODES} from "./errorCodes";
import {removeUndefined} from "../helpers";
import AddFailResult from "../connect/result/AddFailResult";
import {AxiosError} from "axios";

export default class MadmaxError extends Error {

    code: number|string;
    msg: string;
    fetchType: string;
    error: AxiosError;
    buttons: Array<{text: string, action: string}>;
    window_messages: string = undefined;

    private _failResult: AddFailResult;

    private showMessageTag: boolean = false;

    constructor(code: string|number, msg: string = "", fetchType = null, error = null, buttons = null) {
        super(msg)
        this.code = code != null ? code : ERROR_CODES.UNDEFINED;
        this.msg = msg || error;
        this.fetchType = fetchType;
        this.error = error;
        this.buttons = buttons || [];

        // if tags contains "show_message" show sent message
        if (error?.response?.data?.tags) {
            for (let tag of error.response.data.tags) {
                switch (tag) {
                    case "show_message":
                        this.msg = error.response.data.message;
                        this.showMessageTag = true;
                        break;
                    default:
                        break;
                }
            }
        }

        // save iforium JavascriptWalletMessage
        if (error?.response?.data?.window_messages) {
            this.window_messages = error.response.data.window_messages;
        }

        /**
         * @type {AddFailResult}
         * @private
         */
        this._failResult = null;
        Object.setPrototypeOf(this, MadmaxError.prototype);
    }

    isTimeout() {
        return this.code == ERROR_CODES.CONNECTION_TIMEOUT;
    }

    isBadRequest():boolean {
        return this.code == ERROR_CODES.BAD_REQUEST;
    }

    isNetworkError() {
        return this.isTimeout() || this.isBadRequest();
    }

    setFailResult(failResult: AddFailResult) {
        this._failResult = failResult;
    }

    setFetchType(fetchType) {
        this.fetchType = fetchType;
    }

    getFailResult(): AddFailResult {
        return this._failResult;
    }

    getShowMessageTag() {
        return this.showMessageTag;
    }
}

// MadmaxError.prototype.toString = function() {
//     if(this.error) return this.error.toString();
//     return `${this.code} | ${this.msg} | ${this.fetchType}`;
// };

/**
 *
 * @param code
 * @param msg
 * @param fetchType
 * @param {Error} error
 * @return {MadmaxError|*}
 */
export function errorFactroy({code, msg, fetchType, error = null, buttons=[]}: {code?: string|number, msg?: string, fetchType?: string, error?: Error, buttons?: Array<{text: string, action: string}>}): MadmaxError {
    
    let errorData = getMadmaxErrorData(error);
    let params = removeUndefined({code, msg, fetchType});
    
    if(error && !Object.keys(params).length && !errorData) {
        return new MadmaxError(params.code ?? ERROR_CODES.ERROR, error.toString(), fetchType, error, buttons);
    }
    
    let data = {...errorData, ...params};

    return new MadmaxError(data.code, data.msg, data.fetchType, error, buttons);
}

/**
 * @param error
 * @return {null|{code: string}|{msg: *, code: string}|{cpde: string, msg: string}}
 */
function getMadmaxErrorData(error = null) {

    if(!error) {
        return null;
    }

    if (error.response) {

        let data = error.response.data;

        if(data) {

            return {
                code: data.err_code != null ? data.err_code : ERROR_CODES.UNDEFINED,
                msg: data.message
            };
        }

        return {
            code: ERROR_CODES.BAD_RESPONSE,
            msg: "Response data not defined!"
        }
    }

    if(error.code === ERROR_CODES.ECONNABORTED) {
        return {
            code: ERROR_CODES.CONNECTION_TIMEOUT,
        }
    }

    if(error.request) {
        return {
            code: ERROR_CODES.BAD_REQUEST
        }
    }

    return null;
}

// export function createError(error, {code, type, msg, fetchType }) {
//
//     if (error.response) {
//         // The request was made and the server responded with a status code
//         // that falls out of the range of 2xx
//
//         if(error.response.data) {
//
//             let code = error.response.data.err_code ? error.response.data.err_code : "_undefiend";
//             let msg = error.response.data.message ? error.response.data.message : "";
//
//             return new MadmaxError({type: ERROR_TYPES.BAD_RESPONSE, code: code, msg: msg, fetchType: fetchType, error });
//         }
//
//         // console.log(error.response.data);
//         // console.log(error.response.status);
//         // console.log(error.response.headers);
//
//         return new MadmaxError({code: ERROR_CODES.UNKNOW, type: ERROR_TYPES.FATAL, msg: "Response data not defined!", fetchType: fetchType, error });
//
//     } else if (error.request) {
//
//         // The request was made but no response was received
//         // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
//         // http.ClientRequest in node.js
//
//         // console.warn(error.request);
//
//         if(error.code === "ECONNABORTED") {
//             return new MadmaxError({type: ERROR_TYPES.CONNECTION_TIMEOUT, code: ERROR_CODES.CONNECTION_TIMEOUT, fetchType: fetchType, error });
//         }
//
//         return new MadmaxError({type: ERROR_TYPES.BAD_REQUEST, fetchType: fetchType, error})
//
//     } else {
//         // Something happened in setting up the request that triggered an Error
//         // console.warn('Error', error, error.message);
//         let msg = error.message || error;
//
//         return new MadmaxError({code: ERROR_CODES.UNKNOW, type: ERROR_TYPES.FATAL, msg: msg, fetchType: fetchType, error });
//     }
// }